import { toastr } from 'react-redux-toastr'
import branditRails from '../../../../api/brandit_rails'
import {
  setThirdPartyBillingsAction,
  setThirdPartyBillingsStatusAction,
  setThirdPartyBillingsErrorsAction,
  clearThirdPartyBillingsErrorsAction
} from './thirdPartyBillings.actions'

export const fetchThirdPartyBillings = () => async dispatch => {
  try {
    dispatch(setThirdPartyBillingsStatusAction('loading'))
    dispatch(clearThirdPartyBillingsErrorsAction())

    const { data } = await branditRails.get('/third_party_billings')

    dispatch(setThirdPartyBillingsAction(data))
    dispatch(setThirdPartyBillingsStatusAction('succeeded'))

    return data
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setThirdPartyBillingsErrorsAction({ message: errorMessage }))
    dispatch(setThirdPartyBillingsStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}

export const createThirdPartyBilling = billingData => async dispatch => {
  try {
    dispatch(setThirdPartyBillingsStatusAction('loading'))
    dispatch(clearThirdPartyBillingsErrorsAction())

    const response = await branditRails.post('/third_party_billings', billingData)

    // After successful creation, fetch the updated list
    await dispatch(fetchThirdPartyBillings())

    toastr.success('Success', 'Third-party billing account created successfully')
    return response
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setThirdPartyBillingsErrorsAction({ message: errorMessage }))
    dispatch(setThirdPartyBillingsStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}

export const updateThirdPartyBilling = (billingId, billingData) => async dispatch => {
  try {
    dispatch(setThirdPartyBillingsStatusAction('loading'))
    dispatch(clearThirdPartyBillingsErrorsAction())

    const { data } = await branditRails.patch(`/third_party_billings/${billingId}`, billingData)

    // Fetch fresh third party billings data after update
    await dispatch(fetchThirdPartyBillings())

    dispatch(setThirdPartyBillingsStatusAction('succeeded'))
    toastr.success('Third-Party Billing', 'Third-party billing account updated successfully!')

    return data
  } catch (err) {
    const errorMessage = err.response?.data?.errors || err.message
    dispatch(setThirdPartyBillingsErrorsAction({ message: errorMessage }))
    dispatch(setThirdPartyBillingsStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}

export const deleteThirdPartyBilling = billingId => async dispatch => {
  try {
    dispatch(setThirdPartyBillingsStatusAction('loading'))
    dispatch(clearThirdPartyBillingsErrorsAction())

    await branditRails.delete(`/third_party_billings/${billingId}`)

    // Fetch fresh third party billings data after deletion
    await dispatch(fetchThirdPartyBillings())

    dispatch(setThirdPartyBillingsStatusAction('succeeded'))
    toastr.success('Third-Party Billing', 'Third-party billing account deleted successfully!')
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setThirdPartyBillingsErrorsAction({ message: errorMessage }))
    dispatch(setThirdPartyBillingsStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}
